// JavaScript Document
const strLink1="https://interior-arne.com/products/"
function setGoods(url,haba,depth,height,color,form){
this.url=url;
this.haba=haba;
this.depth=depth;
this.height=height;
this.color=color;
this.form=form;
}
function searchURL(){
var habaValue=document.getElementById("haba").value;
var depthValue=document.getElementById("depth").value;
var heightValue=document.getElementById("height").value;
var idColor = document.getElementsByName( "colortype" ) ;
for ( colorValue="", i=idColor.length; i--; ) {
 if ( idColor[i].checked ) {
  colorValue = idColor[i].id ;
  break ;
 }
}
if(habaValue=="haba-select" && depthValue=="depth-selected" && heightValue=="height-selected"){
alert("「幅・奥行・高さ」を選んでください");
return false;
}
if(habaValue=="haba-select" && depthValue=="depth-selected"){
alert("「幅・奥行」を選んでください");
return false;
}
if(habaValue=="haba-select" && heightValue=="height-selected"){
alert("「幅・高さ」を選んでください");
return false;
}
if(depthValue=="depth-selected" && heightValue=="height-selected"){
alert("「奥行・高さ」を選んでください");
return false;
}
if(habaValue=="haba-select"){
alert("「幅」を選んでください");
return false;
}
if(depthValue=="depth-selected"){
alert("「奥行」を選んでください");
return false;
}
if(heightValue=="height-selected"){
alert("「高さ」を選んでください");
return false;
}
if(colorValue==""){
alert("「カラー」を選んでください");
return false;
}
var url=document.getElementById("link_url");
for(var i in goods){
if(goods[i].haba==habaValue && goods[i].depth==depthValue && goods[i].height==heightValue && goods[i].color==colorValue){
return goods[i].url;
}
}
alert("ご希望サイズ幅"+habaValue+"cm×奥行"+depthValue+"cm×高さ"+heightValue+"cmは購入ページのご用意がございません。\nお手数をおかけしますがお見積りを出しますので当店までお問合せくださいませ。");
return false;
}
function jump(){
var idColor = document.getElementsByName( "colortype" ) ;
for ( strColor="", i=idColor.length; i--; ) {
 if ( idColor[i].checked ) {
  strColor = idColor[i].id ;
  var valueColor = idColor[i].value ;
  break ;
 }
}
var url=searchURL();
if(!url){
return false;
}
window.open(strLink1+url)
return false;
}
goods = new Object();
goods[0] =new setGoods("0000ac005461","60","35","80","wood","normal");
goods[1] =new setGoods("0000ac005468","70","35","80","wood","normal");
goods[2] =new setGoods("0000ac005475","80","35","80","wood","normal");
goods[3] =new setGoods("0000ac005482","90","35","80","wood","normal");
goods[4] =new setGoods("0000ac005489","100","35","80","wood","normal");
goods[5] =new setGoods("0000ac005496","110","35","80","wood","normal");
goods[6] =new setGoods("0000ac005503","120","35","80","wood","normal");
goods[7] =new setGoods("0000ac005510","130","35","80","wood","normal");
goods[8] =new setGoods("0000ac005517","140","35","80","wood","normal");
goods[9] =new setGoods("0000ac005524","150","35","80","wood","normal");
goods[10] =new setGoods("0000ac005531","160","35","80","wood","normal");
goods[11] =new setGoods("0000ac005538","170","35","80","wood","normal");
goods[12] =new setGoods("0000ac005545","180","35","80","wood","normal");
goods[13] =new setGoods("0000ac005552","60","40","80","wood","normal");
goods[14] =new setGoods("0000ac005559","70","40","80","wood","normal");
goods[15] =new setGoods("0000ac005566","80","40","80","wood","normal");
goods[16] =new setGoods("0000ac005573","90","40","80","wood","normal");
goods[17] =new setGoods("0000ac005580","100","40","80","wood","normal");
goods[18] =new setGoods("0000ac005587","110","40","80","wood","normal");
goods[19] =new setGoods("0000ac005594","120","40","80","wood","normal");
goods[20] =new setGoods("0000ac005601","130","40","80","wood","normal");
goods[21] =new setGoods("0000ac005608","140","40","80","wood","normal");
goods[22] =new setGoods("0000ac005615","150","40","80","wood","normal");
goods[23] =new setGoods("0000ac005622","160","40","80","wood","normal");
goods[24] =new setGoods("0000ac005629","170","40","80","wood","normal");
goods[25] =new setGoods("0000ac005636","180","40","80","wood","normal");
goods[26] =new setGoods("0000ac005643","60","45","80","wood","normal");
goods[27] =new setGoods("0000ac005650","70","45","80","wood","normal");
goods[28] =new setGoods("0000ac005657","80","45","80","wood","normal");
goods[29] =new setGoods("0000ac005664","90","45","80","wood","normal");
goods[30] =new setGoods("0000ac005671","100","45","80","wood","normal");
goods[31] =new setGoods("0000ac005678","110","45","80","wood","normal");
goods[32] =new setGoods("0000ac005685","120","45","80","wood","normal");
goods[33] =new setGoods("0000ac005692","130","45","80","wood","normal");
goods[34] =new setGoods("0000ac005699","140","45","80","wood","normal");
goods[35] =new setGoods("0000ac005706","150","45","80","wood","normal");
goods[36] =new setGoods("0000ac005713","160","45","80","wood","normal");
goods[37] =new setGoods("0000ac005720","170","45","80","wood","normal");
goods[38] =new setGoods("0000ac005727","180","45","80","wood","normal");
goods[39] =new setGoods("0000ac005734","60","50","80","wood","normal");
goods[40] =new setGoods("0000ac005741","70","50","80","wood","normal");
goods[41] =new setGoods("0000ac005748","80","50","80","wood","normal");
goods[42] =new setGoods("0000ac005755","90","50","80","wood","normal");
goods[43] =new setGoods("0000ac005762","100","50","80","wood","normal");
goods[44] =new setGoods("0000ac005769","110","50","80","wood","normal");
goods[45] =new setGoods("0000ac005776","120","50","80","wood","normal");
goods[46] =new setGoods("0000ac005783","130","50","80","wood","normal");
goods[47] =new setGoods("0000ac005790","140","50","80","wood","normal");
goods[48] =new setGoods("0000ac005797","150","50","80","wood","normal");
goods[49] =new setGoods("0000ac005804","160","50","80","wood","normal");
goods[50] =new setGoods("0000ac005811","170","50","80","wood","normal");
goods[51] =new setGoods("0000ac005818","180","50","80","wood","normal");
goods[52] =new setGoods("0000ac005825","60","55","80","wood","normal");
goods[53] =new setGoods("0000ac005832","70","55","80","wood","normal");
goods[54] =new setGoods("0000ac005839","80","55","80","wood","normal");
goods[55] =new setGoods("0000ac005846","90","55","80","wood","normal");
goods[56] =new setGoods("0000ac005853","100","55","80","wood","normal");
goods[57] =new setGoods("0000ac005860","110","55","80","wood","normal");
goods[58] =new setGoods("0000ac005867","120","55","80","wood","normal");
goods[59] =new setGoods("0000ac005874","130","55","80","wood","normal");
goods[60] =new setGoods("0000ac005881","140","55","80","wood","normal");
goods[61] =new setGoods("0000ac005888","150","55","80","wood","normal");
goods[62] =new setGoods("0000ac005895","160","55","80","wood","normal");
goods[63] =new setGoods("0000ac005902","170","55","80","wood","normal");
goods[64] =new setGoods("0000ac005909","180","55","80","wood","normal");
goods[65] =new setGoods("0000ac005916","60","60","80","wood","normal");
goods[66] =new setGoods("0000ac005923","70","60","80","wood","normal");
goods[67] =new setGoods("0000ac005930","80","60","80","wood","normal");
goods[68] =new setGoods("0000ac005937","90","60","80","wood","normal");
goods[69] =new setGoods("0000ac005944","100","60","80","wood","normal");
goods[70] =new setGoods("0000ac005951","110","60","80","wood","normal");
goods[71] =new setGoods("0000ac005958","120","60","80","wood","normal");
goods[72] =new setGoods("0000ac005965","130","60","80","wood","normal");
goods[73] =new setGoods("0000ac005972","140","60","80","wood","normal");
goods[74] =new setGoods("0000ac005979","150","60","80","wood","normal");
goods[75] =new setGoods("0000ac005986","160","60","80","wood","normal");
goods[76] =new setGoods("0000ac005993","170","60","80","wood","normal");
goods[77] =new setGoods("0000ac006000","180","60","80","wood","normal");
goods[78] =new setGoods("0000ac006007","60","35","90","wood","normal");
goods[79] =new setGoods("0000ac006014","70","35","90","wood","normal");
goods[80] =new setGoods("0000ac006021","80","35","90","wood","normal");
goods[81] =new setGoods("0000ac006028","90","35","90","wood","normal");
goods[82] =new setGoods("0000ac006035","100","35","90","wood","normal");
goods[83] =new setGoods("0000ac006042","110","35","90","wood","normal");
goods[84] =new setGoods("0000ac006049","120","35","90","wood","normal");
goods[85] =new setGoods("0000ac006056","130","35","90","wood","normal");
goods[86] =new setGoods("0000ac006063","140","35","90","wood","normal");
goods[87] =new setGoods("0000ac006070","150","35","90","wood","normal");
goods[88] =new setGoods("0000ac006077","160","35","90","wood","normal");
goods[89] =new setGoods("0000ac006084","170","35","90","wood","normal");
goods[90] =new setGoods("0000ac006091","180","35","90","wood","normal");
goods[91] =new setGoods("0000ac006098","60","40","90","wood","normal");
goods[92] =new setGoods("0000ac006105","70","40","90","wood","normal");
goods[93] =new setGoods("0000ac006112","80","40","90","wood","normal");
goods[94] =new setGoods("0000ac006119","90","40","90","wood","normal");
goods[95] =new setGoods("0000ac006126","100","40","90","wood","normal");
goods[96] =new setGoods("0000ac006133","110","40","90","wood","normal");
goods[97] =new setGoods("0000ac006140","120","40","90","wood","normal");
goods[98] =new setGoods("0000ac006147","130","40","90","wood","normal");
goods[99] =new setGoods("0000ac006154","140","40","90","wood","normal");
goods[100] =new setGoods("0000ac006161","150","40","90","wood","normal");
goods[101] =new setGoods("0000ac006168","160","40","90","wood","normal");
goods[102] =new setGoods("0000ac006175","170","40","90","wood","normal");
goods[103] =new setGoods("0000ac006182","180","40","90","wood","normal");
goods[104] =new setGoods("0000ac006189","60","45","90","wood","normal");
goods[105] =new setGoods("0000ac006196","70","45","90","wood","normal");
goods[106] =new setGoods("0000ac006203","80","45","90","wood","normal");
goods[107] =new setGoods("0000ac006210","90","45","90","wood","normal");
goods[108] =new setGoods("0000ac006217","100","45","90","wood","normal");
goods[109] =new setGoods("0000ac006224","110","45","90","wood","normal");
goods[110] =new setGoods("0000ac006231","120","45","90","wood","normal");
goods[111] =new setGoods("0000ac006238","130","45","90","wood","normal");
goods[112] =new setGoods("0000ac006245","140","45","90","wood","normal");
goods[113] =new setGoods("0000ac006252","150","45","90","wood","normal");
goods[114] =new setGoods("0000ac006259","160","45","90","wood","normal");
goods[115] =new setGoods("0000ac006266","170","45","90","wood","normal");
goods[116] =new setGoods("0000ac006273","180","45","90","wood","normal");
goods[117] =new setGoods("0000ac006280","60","50","90","wood","normal");
goods[118] =new setGoods("0000ac006287","70","50","90","wood","normal");
goods[119] =new setGoods("0000ac006294","80","50","90","wood","normal");
goods[120] =new setGoods("0000ac006301","90","50","90","wood","normal");
goods[121] =new setGoods("0000ac006308","100","50","90","wood","normal");
goods[122] =new setGoods("0000ac006315","110","50","90","wood","normal");
goods[123] =new setGoods("0000ac006322","120","50","90","wood","normal");
goods[124] =new setGoods("0000ac006329","130","50","90","wood","normal");
goods[125] =new setGoods("0000ac006336","140","50","90","wood","normal");
goods[126] =new setGoods("0000ac006343","150","50","90","wood","normal");
goods[127] =new setGoods("0000ac006350","160","50","90","wood","normal");
goods[128] =new setGoods("0000ac006357","170","50","90","wood","normal");
goods[129] =new setGoods("0000ac006364","180","50","90","wood","normal");
goods[130] =new setGoods("0000ac006371","60","55","90","wood","normal");
goods[131] =new setGoods("0000ac006378","70","55","90","wood","normal");
goods[132] =new setGoods("0000ac006385","80","55","90","wood","normal");
goods[133] =new setGoods("0000ac006392","90","55","90","wood","normal");
goods[134] =new setGoods("0000ac006399","100","55","90","wood","normal");
goods[135] =new setGoods("0000ac006406","110","55","90","wood","normal");
goods[136] =new setGoods("0000ac006413","120","55","90","wood","normal");
goods[137] =new setGoods("0000ac006420","130","55","90","wood","normal");
goods[138] =new setGoods("0000ac006427","140","55","90","wood","normal");
goods[139] =new setGoods("0000ac006434","150","55","90","wood","normal");
goods[140] =new setGoods("0000ac006441","160","55","90","wood","normal");
goods[141] =new setGoods("0000ac006448","170","55","90","wood","normal");
goods[142] =new setGoods("0000ac006455","180","55","90","wood","normal");
goods[143] =new setGoods("0000ac006462","60","60","90","wood","normal");
goods[144] =new setGoods("0000ac006469","70","60","90","wood","normal");
goods[145] =new setGoods("0000ac006476","80","60","90","wood","normal");
goods[146] =new setGoods("0000ac006483","90","60","90","wood","normal");
goods[147] =new setGoods("0000ac006490","100","60","90","wood","normal");
goods[148] =new setGoods("0000ac006497","110","60","90","wood","normal");
goods[149] =new setGoods("0000ac006504","120","60","90","wood","normal");
goods[150] =new setGoods("0000ac006511","130","60","90","wood","normal");
goods[151] =new setGoods("0000ac006518","140","60","90","wood","normal");
goods[152] =new setGoods("0000ac006525","150","60","90","wood","normal");
goods[153] =new setGoods("0000ac006532","160","60","90","wood","normal");
goods[154] =new setGoods("0000ac006539","170","60","90","wood","normal");
goods[155] =new setGoods("0000ac006546","180","60","90","wood","normal");
goods[156] =new setGoods("0000ac006553","60","35","100","wood","normal");
goods[157] =new setGoods("0000ac006560","70","35","100","wood","normal");
goods[158] =new setGoods("0000ac006567","80","35","100","wood","normal");
goods[159] =new setGoods("0000ac006574","90","35","100","wood","normal");
goods[160] =new setGoods("0000ac006581","100","35","100","wood","normal");
goods[161] =new setGoods("0000ac006588","110","35","100","wood","normal");
goods[162] =new setGoods("0000ac006595","120","35","100","wood","normal");
goods[163] =new setGoods("0000ac006602","130","35","100","wood","normal");
goods[164] =new setGoods("0000ac006609","140","35","100","wood","normal");
goods[165] =new setGoods("0000ac006616","150","35","100","wood","normal");
goods[166] =new setGoods("0000ac006623","160","35","100","wood","normal");
goods[167] =new setGoods("0000ac006630","170","35","100","wood","normal");
goods[168] =new setGoods("0000ac006637","180","35","100","wood","normal");
goods[169] =new setGoods("0000ac006644","60","40","100","wood","normal");
goods[170] =new setGoods("0000ac006651","70","40","100","wood","normal");
goods[171] =new setGoods("0000ac006658","80","40","100","wood","normal");
goods[172] =new setGoods("0000ac006665","90","40","100","wood","normal");
goods[173] =new setGoods("0000ac006672","100","40","100","wood","normal");
goods[174] =new setGoods("0000ac006679","110","40","100","wood","normal");
goods[175] =new setGoods("0000ac006686","120","40","100","wood","normal");
goods[176] =new setGoods("0000ac006693","130","40","100","wood","normal");
goods[177] =new setGoods("0000ac006700","140","40","100","wood","normal");
goods[178] =new setGoods("0000ac006707","150","40","100","wood","normal");
goods[179] =new setGoods("0000ac006714","160","40","100","wood","normal");
goods[180] =new setGoods("0000ac006721","170","40","100","wood","normal");
goods[181] =new setGoods("0000ac006728","180","40","100","wood","normal");
goods[182] =new setGoods("0000ac006735","60","45","100","wood","normal");
goods[183] =new setGoods("0000ac006742","70","45","100","wood","normal");
goods[184] =new setGoods("0000ac006749","80","45","100","wood","normal");
goods[185] =new setGoods("0000ac006756","90","45","100","wood","normal");
goods[186] =new setGoods("0000ac006763","100","45","100","wood","normal");
goods[187] =new setGoods("0000ac006770","110","45","100","wood","normal");
goods[188] =new setGoods("0000ac006777","120","45","100","wood","normal");
goods[189] =new setGoods("0000ac006784","130","45","100","wood","normal");
goods[190] =new setGoods("0000ac006791","140","45","100","wood","normal");
goods[191] =new setGoods("0000ac006798","150","45","100","wood","normal");
goods[192] =new setGoods("0000ac006805","160","45","100","wood","normal");
goods[193] =new setGoods("0000ac006812","170","45","100","wood","normal");
goods[194] =new setGoods("0000ac006819","180","45","100","wood","normal");
goods[195] =new setGoods("0000ac006826","60","50","100","wood","normal");
goods[196] =new setGoods("0000ac006833","70","50","100","wood","normal");
goods[197] =new setGoods("0000ac006840","80","50","100","wood","normal");
goods[198] =new setGoods("0000ac006847","90","50","100","wood","normal");
goods[199] =new setGoods("0000ac006854","100","50","100","wood","normal");
goods[200] =new setGoods("0000ac006861","110","50","100","wood","normal");
goods[201] =new setGoods("0000ac006868","120","50","100","wood","normal");
goods[202] =new setGoods("0000ac006875","130","50","100","wood","normal");
goods[203] =new setGoods("0000ac006882","140","50","100","wood","normal");
goods[204] =new setGoods("0000ac006889","150","50","100","wood","normal");
goods[205] =new setGoods("0000ac006896","160","50","100","wood","normal");
goods[206] =new setGoods("0000ac006903","170","50","100","wood","normal");
goods[207] =new setGoods("0000ac006910","180","50","100","wood","normal");
goods[208] =new setGoods("0000ac006917","60","55","100","wood","normal");
goods[209] =new setGoods("0000ac006924","70","55","100","wood","normal");
goods[210] =new setGoods("0000ac006931","80","55","100","wood","normal");
goods[211] =new setGoods("0000ac006938","90","55","100","wood","normal");
goods[212] =new setGoods("0000ac006945","100","55","100","wood","normal");
goods[213] =new setGoods("0000ac006952","110","55","100","wood","normal");
goods[214] =new setGoods("0000ac006959","120","55","100","wood","normal");
goods[215] =new setGoods("0000ac006966","130","55","100","wood","normal");
goods[216] =new setGoods("0000ac006973","140","55","100","wood","normal");
goods[217] =new setGoods("0000ac006980","150","55","100","wood","normal");
goods[218] =new setGoods("0000ac006987","160","55","100","wood","normal");
goods[219] =new setGoods("0000ac006994","170","55","100","wood","normal");
goods[220] =new setGoods("0000ac007001","180","55","100","wood","normal");
goods[221] =new setGoods("0000ac007008","60","60","100","wood","normal");
goods[222] =new setGoods("0000ac007015","70","60","100","wood","normal");
goods[223] =new setGoods("0000ac007022","80","60","100","wood","normal");
goods[224] =new setGoods("0000ac007029","90","60","100","wood","normal");
goods[225] =new setGoods("0000ac007036","100","60","100","wood","normal");
goods[226] =new setGoods("0000ac007043","110","60","100","wood","normal");
goods[227] =new setGoods("0000ac007050","120","60","100","wood","normal");
goods[228] =new setGoods("0000ac007057","130","60","100","wood","normal");
goods[229] =new setGoods("0000ac007064","140","60","100","wood","normal");
goods[230] =new setGoods("0000ac007071","150","60","100","wood","normal");
goods[231] =new setGoods("0000ac007078","160","60","100","wood","normal");
goods[232] =new setGoods("0000ac007085","170","60","100","wood","normal");
goods[233] =new setGoods("0000ac007092","180","60","100","wood","normal");
goods[234] =new setGoods("0000ac007099","60","35","110","wood","normal");
goods[235] =new setGoods("0000ac007106","70","35","110","wood","normal");
goods[236] =new setGoods("0000ac007113","80","35","110","wood","normal");
goods[237] =new setGoods("0000ac007120","90","35","110","wood","normal");
goods[238] =new setGoods("0000ac007127","100","35","110","wood","normal");
goods[239] =new setGoods("0000ac007134","110","35","110","wood","normal");
goods[240] =new setGoods("0000ac007141","120","35","110","wood","normal");
goods[241] =new setGoods("0000ac007148","130","35","110","wood","normal");
goods[242] =new setGoods("0000ac007155","140","35","110","wood","normal");
goods[243] =new setGoods("0000ac007162","150","35","110","wood","normal");
goods[244] =new setGoods("0000ac007169","160","35","110","wood","normal");
goods[245] =new setGoods("0000ac007176","170","35","110","wood","normal");
goods[246] =new setGoods("0000ac007183","180","35","110","wood","normal");
goods[247] =new setGoods("0000ac007190","60","40","110","wood","normal");
goods[248] =new setGoods("0000ac007197","70","40","110","wood","normal");
goods[249] =new setGoods("0000ac007204","80","40","110","wood","normal");
goods[250] =new setGoods("0000ac007211","90","40","110","wood","normal");
goods[251] =new setGoods("0000ac007218","100","40","110","wood","normal");
goods[252] =new setGoods("0000ac007225","110","40","110","wood","normal");
goods[253] =new setGoods("0000ac007232","120","40","110","wood","normal");
goods[254] =new setGoods("0000ac007239","130","40","110","wood","normal");
goods[255] =new setGoods("0000ac007246","140","40","110","wood","normal");
goods[256] =new setGoods("0000ac007253","150","40","110","wood","normal");
goods[257] =new setGoods("0000ac007260","160","40","110","wood","normal");
goods[258] =new setGoods("0000ac007267","170","40","110","wood","normal");
goods[259] =new setGoods("0000ac007274","180","40","110","wood","normal");
goods[260] =new setGoods("0000ac007281","60","45","110","wood","normal");
goods[261] =new setGoods("0000ac007288","70","45","110","wood","normal");
goods[262] =new setGoods("0000ac007295","80","45","110","wood","normal");
goods[263] =new setGoods("0000ac007302","90","45","110","wood","normal");
goods[264] =new setGoods("0000ac007309","100","45","110","wood","normal");
goods[265] =new setGoods("0000ac007316","110","45","110","wood","normal");
goods[266] =new setGoods("0000ac007323","120","45","110","wood","normal");
goods[267] =new setGoods("0000ac007330","130","45","110","wood","normal");
goods[268] =new setGoods("0000ac007337","140","45","110","wood","normal");
goods[269] =new setGoods("0000ac007344","150","45","110","wood","normal");
goods[270] =new setGoods("0000ac007351","160","45","110","wood","normal");
goods[271] =new setGoods("0000ac007358","170","45","110","wood","normal");
goods[272] =new setGoods("0000ac007365","180","45","110","wood","normal");
goods[273] =new setGoods("0000ac007372","60","50","110","wood","normal");
goods[274] =new setGoods("0000ac007379","70","50","110","wood","normal");
goods[275] =new setGoods("0000ac007386","80","50","110","wood","normal");
goods[276] =new setGoods("0000ac007393","90","50","110","wood","normal");
goods[277] =new setGoods("0000ac007400","100","50","110","wood","normal");
goods[278] =new setGoods("0000ac007407","110","50","110","wood","normal");
goods[279] =new setGoods("0000ac007414","120","50","110","wood","normal");
goods[280] =new setGoods("0000ac007421","130","50","110","wood","normal");
goods[281] =new setGoods("0000ac007428","140","50","110","wood","normal");
goods[282] =new setGoods("0000ac007435","150","50","110","wood","normal");
goods[283] =new setGoods("0000ac007442","160","50","110","wood","normal");
goods[284] =new setGoods("0000ac007449","170","50","110","wood","normal");
goods[285] =new setGoods("0000ac007456","180","50","110","wood","normal");
goods[286] =new setGoods("0000ac007463","60","55","110","wood","normal");
goods[287] =new setGoods("0000ac007470","70","55","110","wood","normal");
goods[288] =new setGoods("0000ac007477","80","55","110","wood","normal");
goods[289] =new setGoods("0000ac007484","90","55","110","wood","normal");
goods[290] =new setGoods("0000ac007491","100","55","110","wood","normal");
goods[291] =new setGoods("0000ac007498","110","55","110","wood","normal");
goods[292] =new setGoods("0000ac007505","120","55","110","wood","normal");
goods[293] =new setGoods("0000ac007512","130","55","110","wood","normal");
goods[294] =new setGoods("0000ac007519","140","55","110","wood","normal");
goods[295] =new setGoods("0000ac007526","150","55","110","wood","normal");
goods[296] =new setGoods("0000ac007533","160","55","110","wood","normal");
goods[297] =new setGoods("0000ac007540","170","55","110","wood","normal");
goods[298] =new setGoods("0000ac007547","180","55","110","wood","normal");
goods[299] =new setGoods("0000ac007554","60","60","110","wood","normal");
goods[300] =new setGoods("0000ac007561","70","60","110","wood","normal");
goods[301] =new setGoods("0000ac007568","80","60","110","wood","normal");
goods[302] =new setGoods("0000ac007575","90","60","110","wood","normal");
goods[303] =new setGoods("0000ac007582","100","60","110","wood","normal");
goods[304] =new setGoods("0000ac007589","110","60","110","wood","normal");
goods[305] =new setGoods("0000ac007596","120","60","110","wood","normal");
goods[306] =new setGoods("0000ac007603","130","60","110","wood","normal");
goods[307] =new setGoods("0000ac007610","140","60","110","wood","normal");
goods[308] =new setGoods("0000ac007617","150","60","110","wood","normal");
goods[309] =new setGoods("0000ac007624","160","60","110","wood","normal");
goods[310] =new setGoods("0000ac007631","170","60","110","wood","normal");
goods[311] =new setGoods("0000ac007638","180","60","110","wood","normal");
goods[312] =new setGoods("0000ac007645","60","35","120","wood","normal");
goods[313] =new setGoods("0000ac007652","70","35","120","wood","normal");
goods[314] =new setGoods("0000ac007659","80","35","120","wood","normal");
goods[315] =new setGoods("0000ac007666","90","35","120","wood","normal");
goods[316] =new setGoods("0000ac007673","100","35","120","wood","normal");
goods[317] =new setGoods("0000ac007680","110","35","120","wood","normal");
goods[318] =new setGoods("0000ac007687","120","35","120","wood","normal");
goods[319] =new setGoods("0000ac007694","130","35","120","wood","normal");
goods[320] =new setGoods("0000ac007701","140","35","120","wood","normal");
goods[321] =new setGoods("0000ac007708","150","35","120","wood","normal");
goods[322] =new setGoods("0000ac007715","160","35","120","wood","normal");
goods[323] =new setGoods("0000ac007722","170","35","120","wood","normal");
goods[324] =new setGoods("0000ac007729","180","35","120","wood","normal");
goods[325] =new setGoods("0000ac007736","60","40","120","wood","normal");
goods[326] =new setGoods("0000ac007743","70","40","120","wood","normal");
goods[327] =new setGoods("0000ac007750","80","40","120","wood","normal");
goods[328] =new setGoods("0000ac007757","90","40","120","wood","normal");
goods[329] =new setGoods("0000ac007764","100","40","120","wood","normal");
goods[330] =new setGoods("0000ac007771","110","40","120","wood","normal");
goods[331] =new setGoods("0000ac007778","120","40","120","wood","normal");
goods[332] =new setGoods("0000ac007785","130","40","120","wood","normal");
goods[333] =new setGoods("0000ac007792","140","40","120","wood","normal");
goods[334] =new setGoods("0000ac007799","150","40","120","wood","normal");
goods[335] =new setGoods("0000ac007806","160","40","120","wood","normal");
goods[336] =new setGoods("0000ac007813","170","40","120","wood","normal");
goods[337] =new setGoods("0000ac007820","180","40","120","wood","normal");
goods[338] =new setGoods("0000ac007827","60","45","120","wood","normal");
goods[339] =new setGoods("0000ac007834","70","45","120","wood","normal");
goods[340] =new setGoods("0000ac007841","80","45","120","wood","normal");
goods[341] =new setGoods("0000ac007848","90","45","120","wood","normal");
goods[342] =new setGoods("0000ac007855","100","45","120","wood","normal");
goods[343] =new setGoods("0000ac007862","110","45","120","wood","normal");
goods[344] =new setGoods("0000ac007869","120","45","120","wood","normal");
goods[345] =new setGoods("0000ac007876","130","45","120","wood","normal");
goods[346] =new setGoods("0000ac007883","140","45","120","wood","normal");
goods[347] =new setGoods("0000ac007890","150","45","120","wood","normal");
goods[348] =new setGoods("0000ac007897","160","45","120","wood","normal");
goods[349] =new setGoods("0000ac007904","170","45","120","wood","normal");
goods[350] =new setGoods("0000ac007911","180","45","120","wood","normal");
goods[351] =new setGoods("0000ac007918","60","50","120","wood","normal");
goods[352] =new setGoods("0000ac007925","70","50","120","wood","normal");
goods[353] =new setGoods("0000ac007932","80","50","120","wood","normal");
goods[354] =new setGoods("0000ac007939","90","50","120","wood","normal");
goods[355] =new setGoods("0000ac007946","100","50","120","wood","normal");
goods[356] =new setGoods("0000ac007953","110","50","120","wood","normal");
goods[357] =new setGoods("0000ac007960","120","50","120","wood","normal");
goods[358] =new setGoods("0000ac007967","130","50","120","wood","normal");
goods[359] =new setGoods("0000ac007974","140","50","120","wood","normal");
goods[360] =new setGoods("0000ac007981","150","50","120","wood","normal");
goods[361] =new setGoods("0000ac007988","160","50","120","wood","normal");
goods[362] =new setGoods("0000ac007995","170","50","120","wood","normal");
goods[363] =new setGoods("0000ac008002","180","50","120","wood","normal");
goods[364] =new setGoods("0000ac008009","60","55","120","wood","normal");
goods[365] =new setGoods("0000ac008016","70","55","120","wood","normal");
goods[366] =new setGoods("0000ac008023","80","55","120","wood","normal");
goods[367] =new setGoods("0000ac008030","90","55","120","wood","normal");
goods[368] =new setGoods("0000ac008037","100","55","120","wood","normal");
goods[369] =new setGoods("0000ac008044","110","55","120","wood","normal");
goods[370] =new setGoods("0000ac008051","120","55","120","wood","normal");
goods[371] =new setGoods("0000ac008058","130","55","120","wood","normal");
goods[372] =new setGoods("0000ac008065","140","55","120","wood","normal");
goods[373] =new setGoods("0000ac008072","150","55","120","wood","normal");
goods[374] =new setGoods("0000ac008079","160","55","120","wood","normal");
goods[375] =new setGoods("0000ac008086","170","55","120","wood","normal");
goods[376] =new setGoods("0000ac008093","180","55","120","wood","normal");
goods[377] =new setGoods("0000ac008100","60","60","120","wood","normal");
goods[378] =new setGoods("0000ac008107","70","60","120","wood","normal");
goods[379] =new setGoods("0000ac008114","80","60","120","wood","normal");
goods[380] =new setGoods("0000ac008121","90","60","120","wood","normal");
goods[381] =new setGoods("0000ac008128","100","60","120","wood","normal");
goods[382] =new setGoods("0000ac008135","110","60","120","wood","normal");
goods[383] =new setGoods("0000ac008142","120","60","120","wood","normal");
goods[384] =new setGoods("0000ac008149","130","60","120","wood","normal");
goods[385] =new setGoods("0000ac008156","140","60","120","wood","normal");
goods[386] =new setGoods("0000ac008163","150","60","120","wood","normal");
goods[387] =new setGoods("0000ac008170","160","60","120","wood","normal");
goods[388] =new setGoods("0000ac008177","170","60","120","wood","normal");
goods[389] =new setGoods("0000ac008184","180","60","120","wood","normal");

